import Menu from "./sections/Menu";
import Footer from "./sections/Footer";

const data = {
  meta: {
    title: "Socialpoint Support",
    description: "Find support for your favourite Socialpoint game",
    keywords:
      "socialpoint, social point, socialpoint support, social point games support, dragon city support, monster legends support, word life support, free to play games support, helpshift"
  },
  menu: Menu(2),
  breadcrumb: {
    color: "white",
    arrow:
      "//sp-tools-website.s3-eu-west-1.amazonaws.com/media/static/arrow-right.svg",
    items: [
      {
        title: "home",
        hrefTo: "/"
      },
      {
        title: "support",
        hrefTo: "/support"
      }
    ]
  },
  components: [
    {
      name: "Wrapper",
      props: {
        backgroundColor: "purple"
      },
      components: [
        {
          name: "Container",
          props: {
            className: "pt-40 md:pt-64"
          },
          components: [
            {
              name: "Title1",
              props: {
                text: "Find support\nfor your favourite game",
                color: "white"
              }
            }
          ]
        },
        {
          name: "Games",
          props: {
            title: null,
            items: [
              {
                id: "2",
                background:
                  "//sp-tools-website.s3-eu-west-1.amazonaws.com/media/sections/games/Vertical_Card_DC.jpg",
                logo:
                  "//sp-tools-website.s3-eu-west-1.amazonaws.com/media/static/logos/DC-logo-2022-2.png",
                hrefTo: "https://socialpoint.helpshift.com/a/dragon-city/",
                title: "Dragon City"
              },
              {
                id: "3",
                background:
                  "//sp-tools-website.s3-eu-west-1.amazonaws.com/media/games/two-dots/Vertical_Card_TD.jpeg",
                logo:
                  "//sp-tools-website.s3-eu-west-1.amazonaws.com/media/games/two-dots/TD-logo.png",
                hrefTo: "https://dots.helpshift.com/hc/en/3-two-dots/",
                title: "Two Dots"
              },
              {
                id: "4",
                background:
                  "//sp-tools-website.s3-eu-west-1.amazonaws.com/media/sections/games/Vertical_Card_ML.jpg",
                logo:
                  "//sp-tools-website.s3-eu-west-1.amazonaws.com/media/static/logos/ML-logo-2021.png",
                hrefTo: "https://socialpoint.helpshift.com/a/monster-legends/",
                title: "Monster Legends"
              },
              {
                id: "5",
                background:
                  "//sp-tools-website.s3-eu-west-1.amazonaws.com/media/sections/games/Vertical_Card_WL.jpg",
                logo:
                  "//sp-tools-website.s3-eu-west-1.amazonaws.com/media/static/logos/WL-logo-2021.png",
                hrefTo: "https://socialpoint.helpshift.com/a/word-life/",
                title: "Word Life"
              }
            ]
          }
        },
        {
          name: "Separator",
          props: {
            topColor: "purple",
            bottomColor: "gray"
          }
        }
      ]
    } /*
    {
      name: "Wrapper",
      props: {
        backgroundColor: "gray",
      },
      components: [
        /*{
          name: "GameReel",
          props: {
            title: {
              text: "Game reel",
            },
            video: {
              src: "https://vimeo.com/375609316/caf8132bac",
              poster:
                "//sp-tools-website.s3-eu-west-1.amazonaws.com/media/static/support-video-thumbnail.jpg",
              player: {
                src:
                  "//sp-tools-website.s3-eu-west-1.amazonaws.com/media/static/player-play.svg",
                backgroundColor: "white",
                alt: "",
                color: "purple",
              },
            },
          },
        },
        Footer,
      ],
    },*/
  ]
};

export default data;
